export default __webpack_public_path__ + "static/media/peros 2.3eb99e7d.png";